import React from 'react';
import { User, UserGroup } from '@restore/services-lib';
import { DropdownOption } from 'components/DropdownSelect/dropdown.types';
import MultiselectDropdown from 'components/DropdownSelect/MultiSelectDropdown/MultiselectDropdown';
import { useUsersContext } from 'context/users.context';

export const getUserGroupSelectDropdownOptions = (userGroups: UserGroup[]): DropdownOption[] =>
  userGroups.map((userGroup) => ({
    name: userGroup.name,
    id: userGroup.id,
  }));

const getSelectedOptions = (user: Partial<User>): DropdownOption[] =>
  user.userGroups?.map((userGroup: UserGroup) => ({ id: userGroup.id, name: userGroup.name })) ??
  [];

interface UserGroupsSelectDropdownInterface {
  user: Partial<User>;
  selectedOptionsOverride?: DropdownOption[];
  onChange: (selectedOptions: DropdownOption[]) => void;
}

const UserGroupsSelectDropdown = ({
  user,
  onChange,
  selectedOptionsOverride,
}: UserGroupsSelectDropdownInterface) => {
  const { userGroups } = useUsersContext();
  const selectedOptions = selectedOptionsOverride ?? getSelectedOptions(user);

  return (
    <MultiselectDropdown
      fieldLabel='User Groups'
      allOptions={getUserGroupSelectDropdownOptions(userGroups)}
      fullWidth={true}
      selected={selectedOptions}
      setSelected={(selectedOptions: DropdownOption[]) => onChange(selectedOptions)}
    />
  );
};

export default UserGroupsSelectDropdown;
